import React from 'react';
import BaseBanner from '~/components/Chrome/Banners/BaseBanner';
import HelpLink from '~/components/Links/HelpLink';
import WarningIcon from '~/public/static/svg/WarningIcon';

interface Props {}

const CanadianTariffWarningBanner: React.FC<Props> = () => {
  return (
    <BaseBanner className="h-auto bg-yellow-600 text-white">
      <WarningIcon className="flex-shrink-0" />
      <div>
        Some of your items can’t be purchased in the US. Update shipping
        settings to make them available.
      </div>
      <div className="w-full flex-1" />
      <HelpLink
        link="usBuyersCannotSeeItems"
        title="Learn more about US buyer restrictions"
        className="flex-shrink-0 underline"
      >
        Learn more
      </HelpLink>
    </BaseBanner>
  );
};

export default CanadianTariffWarningBanner;
